import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import "./aidevelop.css";
import ServiceFooter from "../../ServiceFooter";
import { services, stepsData } from "./data";
import { useState } from "react";
import Step from "../custom-software/Step";
import AIProcess from "./AIProcess";

const AIDevelop = () => {
  const [activeTab, setActiveTab] = useState("step-one");

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const [activeSection, setActiveSection] = useState(null);

  const toggleSection = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };

  return (
    <>
      <NewHead />

      <Helmet>
        <title>AI development company</title>

        <meta name="title" content="AI development company" />
        <meta
          name="description"
          content="Skyrocket your business with Beleaf Technologies' AI development solutions. Experience unparalleled innovation tailored to your specific needs. Revolutionize industries, enhance customer experiences, and safeguard your data with our cutting-edge AI technologies. Discover how our personalized recommendations and robust security solutions can drive your success. Explore the limitless possibilities of AI & ML with Beleaf Technologies today."
        />
        <meta property="og:title" content="AI development company" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/ai-and-ml-development-company"
        />
      </Helmet>

      <main className="ai_dv_main">
        {/* hero */}
        <article className="ai_dv_hero ai_dev_mb_100">
          <div className="primary__landing__container">
            <h1 className="ai_dv_title">AI Development Company</h1>
            <p className="ai_dv_content">
              Sky rocket your business with beleaf technologies AI & ML
              development solutions
            </p>

            <div className="ai_dv_hero_btn_wrap">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="ai_dv_hero_btn"
              >
                <span>Get Free Consultation</span>
              </button>
            </div>
          </div>
          <div className="ai_dv_hero_gif">
            <img
              src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777287799/heroAiDvBannerImg_ywlokt.webp"
              alt="AI development company"
              loading="lazy"
              className="ai_dv_hero_ImgMain"
            />
            {/* <img
              src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1749285267/hero_1_1_qzvkdp.gif"
              alt="AI development company"
              loading="lazy"
            /> */}
          </div>
        </article>

        {/* about */}
        <article className="primary__landing-content-container ai_dev_mb_100 overflow-hidden">
          <div className="ai_dv_abt_outer">
            <div className="ai_dv_abt_inner">
              <div className="row mx-0 g-lg-3 g-4 ai_dv_abt_row">
                <div className="col-lg-5">
                  <h3 className="ai_dv_subtitle ai_dv_abt_title">
                    What is AI development company?
                  </h3>
                  <div className="mt-3">
                    <button
                      data-toggle="modal"
                      data-target="#myModal"
                      className="ai_dv_hero_btn"
                    >
                      <span>Get Started Now</span>
                    </button>
                  </div>
                </div>
                <div className="col-lg-7">
                  <p className="ai_dv_abt_cnt">
                    AI development company entails the creation of intelligent
                    systems capable of autonomous learning and decision-making.
                    It encompasses algorithm design, model training, and
                    leveraging data to enable machines to emulate human
                    intelligence and enhance performance progressively
                  </p>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* services */}
        <article className="primary__landing-content-container ai_dev_mb_120">
          <h3 className="ai_dv_subtitle ai_dv_ser_title">
            Elevate Your Business with Our AI Development Services
          </h3>
          <div>
            {services.map((service, index) => {
              if (index % 2 === 0) {
                return (
                  <div
                    className={`staking-card-list   ${index !== 0 ? "" : ""}`}
                    key={index}
                  >
                    <div className="en_bk_serv_row ai_dv_sr_row row mx-0">
                      <div className="col-lg-6 col-md-6">
                        <div className="en_bk_serv_card en_bk_bor_rgt ai_dv_sr_card">
                          <img
                            src={require(`../../../image/Aidevelop/${service.img}`)}
                            alt="AI development company"
                            loading="lazy"
                            className="ai_dv_sr_img"
                          />
                          <h5>{service.title}</h5>
                          <p>{service.desc}</p>
                        </div>
                      </div>
                      {services[index + 1] && (
                        <div className="col-lg-6 col-md-6">
                          <div className="en_bk_serv_card ai_dv_sr_card">
                            <img
                              src={require(`../../../image/Aidevelop/${
                                services[index + 1].img
                              }`)}
                              alt="AI development company"
                              loading="lazy"
                              className="ai_dv_sr_img"
                            />
                            <h5>{services[index + 1].title}</h5>
                            <p>{services[index + 1].desc}</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              }
              return null;
            })}
          </div>
        </article>

        {/* success */}
        <article className="primary__landing-content-container ai_dev_mb_100 overflow-hidden">
          <div className="row mx-0 g-4 ai_dv_success_row">
            <div className="col-lg-5 pioness_image">
              <img
                src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777288068/robotAiDvPioneeSct_yycbmu.webp"
                alt="AI development company"
                loading="lazy"
                className="ai_dv_rbt robotAiDvPioneeSct"
              />
              {/* <img
                src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1749285319/robot_1_nktiqx.gif"
                alt="AI development company"
                loading="lazy"
                className="ai_dv_rbt"
              /> */}
            </div>
            <div className="col-lg-7">
              <h3 className="ai_dv_subtitle">
                Pioneering Specialized Domains: Unveiling Customized Solutions
                to Elevate Your Success
              </h3>
              <p className="ai_dv_abt_cnt">
                At The Forefront Of Innovation, We Thrive In Specialized Domains
                That Distinguish Us. With Our Deep Understanding Of Intricate
                Concepts And Inventive Strategies, We Offer Unparalleled
                Solutions Customized To Meet Your Distinct Requirements. Our
                Mastery In Specialised Concepts Are As Follows.
              </p>{" "}
              <div className="mt-3">
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="ai_dv_hero_btn"
                >
                  <span>Get Started Now</span>
                </button>
              </div>
            </div>
          </div>
        </article>

        {/* cards */}
        <article className="primary__landing-content-container ai_dev_mb_100 overflow-hidden">
          <div className="row mx-0 g-4">
            <div className="col-lg-4 col-sm-6">
              <div className="ai_dv_cards">
                <img
                  src={require("../../../image/Aidevelop/cd_img_one.webp")}
                  alt="AI development company"
                  loading="lazy"
                />
                <h5>Machine Learning</h5>
                <p>
                  Utilize the potential of machine learning to derive valuable
                  insights from data, automate workflows, and make informed
                  predictions. Empower your business to make data-driven
                  decisions and optimize efficiency effectively
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="ai_dv_cards">
                <img
                  src={require("../../../image/Aidevelop/cd_img_two.webp")}
                  alt="AI development company"
                  loading="lazy"
                />
                <h5>Deep Learning</h5>
                <p>
                  Immerse yourself in the realm of deep learning, where
                  artificial neural networks emulate human brain functions.
                  Unveil intricate patterns, solve complex problems, and unlock
                  groundbreaking opportunities in domains like image
                  recognition, speech synthesis, and autonomous driving
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="ai_dv_cards">
                <img
                  src={require("../../../image/Aidevelop/cd_img_one.webp")}
                  alt="AI development company"
                  loading="lazy"
                />
                <h5>Natural Language Processing</h5>
                <p>
                  Delve into the domain of Natural Language Processing (NLP) to
                  enable machines in understanding, interpreting, and engaging
                  with human language. From sentiment analysis to language
                  translation, leverage NLP to extract meaning, gain invaluable
                  insights, and enhance communication across diverse sectors.
                </p>
              </div>
            </div>
          </div>
        </article>

        {/* industries */}
        <article className="primary__landing-content-container overflow-hidden">
          <h3 className="ai_dv_subtitle ai_dv_ind_title">
            Industries in which our AI development solutions mastered are as
            follows
          </h3>

          <div className="fiu-process-outer erm-approach-outer mb-0">
            {/* Left section */}
            <div className="fiu-process-left ai_dv_ind_lft">
              <ul className="fiu-process-list">
                {stepsData.map((step) => (
                  <Step
                    key={step.id}
                    stepId={step.id}
                    title={step.title}
                    description={step.description}
                    activeTab={activeTab}
                    handleTabClick={handleTabClick}
                  />
                ))}
              </ul>
            </div>

            {/* Right section */}
            <div className="fiu-process-right process-right-none">
              <div
                className="tools_rt_inner process-right-lists"
                id="tools_rt_scroll"
              >
                {stepsData.map((step) => (
                  <AIProcess
                    key={step.id}
                    stepId={step.id}
                    activeTab={activeTab}
                    description={step.content}
                    imageSrc={step.imageSrc}
                  />
                ))}
              </div>
            </div>

            {/* Mobile Accordion */}
            <div className="fiu-process-right process-right-mobile">
              <div
                className="tools_rt_inner process-right-lists"
                id="tools_rt_scroll"
              >
                {stepsData.map((step) => (
                  <div key={step.id} id={step.id}>
                    <div
                      className="techstack__accordian"
                      onClick={() => toggleSection(step.id)}
                    >
                      <div>
                        <span
                          // className="fiu-left-content-title"
                          className={`fiu-left-content-title text-nowrap ${
                            activeSection === step.id ? "active" : ""
                          }`}
                        >
                          {step.title}
                        </span>
                        <span
                          // className="fiu-left-content-title "
                          className={`mx-3 fiu-left-content-title ${
                            activeSection === step.id ? "active" : ""
                          }`}
                        >
                          {step.description}
                        </span>
                      </div>
                    </div>

                    {activeSection === step.id && (
                      <div className="tools-accordion-body">
                        <div className="process-right-content">
                          <div>
                            <img
                              src={step.imageSrc}
                              alt="Custom Software Development Company"
                              className="ai_pr_img"
                            />
                            <h6>{step.content.title}</h6>
                            <p>{step.content.text}</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </article>

        {/* why */}
        <article className="primary__landing-content-container  overflow-hidden">
          <div className="ai_dv_why">
            <img
              src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777278941/why_two_msvdthNew_apd4lp.webp"
              alt="AI development company"
              loading="lazy"
              className="ai_dv_whyNew"
            />
            <h3 className="ai_dv_subtitle ai_dv_why_title">
              Why Choose Beleaf as Your AI Development Company?
            </h3>
            <p className="ai_dv_abt_cnt ai_dv_why_cnt">
              We prioritize your specific requirements, delivering customised
              and innovative solutions of exceptional quality. Experience
              seamless integration and optimised performance as we cater to your
              unique needs and drive your success.
            </p>
            <div className="mt-3 text-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="ai_dv_hero_btn"
              >
                <span>Get Started Now</span>
              </button>
            </div>
          </div>
        </article>
      </main>

      {/* faq */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <button
                          className="landing-faq-title collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          How can Beleaf Technologies' AI solutions skyrocket
                          your business?
                        </button>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Beleaf Technologies' AI solutions have the power to
                          revolutionize your business by leveraging intelligent
                          systems capable of autonomous learning and
                          decision-making. With algorithm design, model
                          training, and data utilization, these solutions enable
                          machines to emulate human intelligence and enhance
                          performance progressively. By tapping into the
                          limitless creativity of generative AI, providing
                          seamless AI chatbot experiences, developing AI
                          products tailored to your business, and implementing
                          powerful recommendation engines, Beleaf Technologies
                          helps elevate your business to new heights of success.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          Which industries can benefit from Beleaf Technologies'
                          AI development services?
                        </div>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Beleaf Technologies specializes in providing AI
                          development services across various industries. Their
                          expertise extends to healthcare, finance, education,
                          logistics, automation, cybersecurity, aviation,
                          research & development, agriculture, and e-commerce.
                          In healthcare, AI technologies enhance diagnostics,
                          personalized treatment plans, and patient care,
                          improving outcomes and cost-efficiency. In finance,
                          these solutions transform operations, automate risk
                          assessment, detect fraud, and deliver personalized
                          financial services. Similarly, Beleaf Technologies
                          offers tailored solutions to optimize operations in
                          education, logistics, automation, cybersecurity,
                          aviation, research & development, agriculture, and
                          e-commerce.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          How can Beleaf Technologies' AI product development
                          services bring your vision to life?
                        </div>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Beleaf Technologies' AI product development services
                          are designed to help you realize your unique vision.
                          They leverage advanced algorithms and cutting-edge
                          technologies to build intelligent and innovative
                          solutions tailored specifically to your business
                          requirements. Whether you aim to automate workflows,
                          enhance customer experiences, optimize operations, or
                          solve complex problems, Beleaf Technologies
                          collaborates with you to develop AI-driven products
                          that unlock your vision's full potential. Their
                          expertise spans a wide range of domains, empowering
                          your business to make data-driven decisions, optimize
                          efficiency, and achieve remarkable outcomes.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq4"
                        >
                          Want personalized recommendations to enhance customer
                          experiences? How can Beleaf Technologies'
                          recommendation engine help?
                        </div>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Beleaf Technologies' recommendation engine is a
                          powerful AI-driven solution that analyzes user
                          preferences and behaviors to deliver personalized
                          recommendations. By harnessing the capabilities of AI,
                          this engine significantly enhances customer
                          experiences and engagement. It goes beyond generic
                          suggestions, providing tailored recommendations that
                          cater to individual tastes and preferences. By
                          leveraging deep insights derived from user data,
                          Beleaf Technologies' recommendation engine can boost
                          conversions, increase customer satisfaction, and
                          foster long-term customer loyalty. It is a valuable
                          tool for businesses aiming to optimize their marketing
                          efforts and deliver targeted recommendations to their
                          customers.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead5">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq5"
                          aria-expanded="true"
                          aria-controls="faq5"
                        >
                          Concerned about data security? How can Beleaf
                          Technologies' AI security solutions protect your
                          business?
                        </div>
                      </div>

                      <div
                        id="faq5"
                        className="collapse"
                        aria-labelledby="faqhead5"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Beleaf Technologies' AI security solutions provide
                          robust protection for your valuable data and systems
                          against cyber threats. Powered by advanced algorithms
                          and machine learning, these solutions continuously
                          monitor and detect anomalies in real-time. By
                          proactively identifying and mitigating threats, Beleaf
                          Technologies ensures that your business remains
                          secure. Their AI security solutions offer
                          comprehensive threat intelligence, enabling the
                          prevention of attacks and safeguarding sensitive data.
                          With Beleaf Technologies' expertise in AI-driven
                          security, you can have peace of mind knowing that your
                          business is protected from evolving cyber threats.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default AIDevelop;
